import React, { useState } from "react";
import { useSelector } from "react-redux";
import getTranslationData from "../../../TranslationUtility/TranslationUtility";
import { LoginV3Data } from "../../Utility/Utility";

const UserInfoAccordion = ({ journeyType }) => {
  const translation = getTranslationData();
  const loginV3Data = LoginV3Data();
  const [open, setOpen] = useState(false);

  const clientConfigData = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData[0],
  );
  const isCollapsible = clientConfigData?.enableCollapsibleUserInfo;

  return (
    <div className="bg-white rightCart bnb bnb1 padding-0">
      <div
        className={`d-flex justify-content-between align-items-center${open || !isCollapsible
          ? "jlkkedit2 editborder"
          : "jlkkedit2 pt-2 pb-2"
          } `}
        onClick={() => setOpen(!open)}
        style={{ cursor: "pointer" }}
      >
        <div className="user-cart jlkkedit2">{translation?.userDetails}</div>
        {isCollapsible && (
          <div className="arrow arrowPad">
            <i className={`fa-solid ${open ? "fa-angle-up" : "fa-angle-down"}`}></i>
          </div>
        )}
      </div>

      {(open || !isCollapsible) && (
        <div className="info">
          <div className="d-flex justify-content-start align-items-center jlkkedit2">
            <div className="mr-4 cartnamefirst">{translation?.nameLabel}</div>
            <div className="cartnamesecond">
              {loginV3Data?.memberProfile?.firstName}{" "}
              {loginV3Data?.memberProfile?.lastName}
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center jlkkedit2">
            <div className="mr-4 cartnamefirst">{translation?.mobileNo}.</div>
            <div className="cartnamesecond">
              {journeyType ? (
                <>
                  {loginV3Data?.memberProfile?.mobileNumber}
                </>
              ) : (
                <>
                  {loginV3Data?.memberProfile?.mobileNumber > 0 && `${loginV3Data?.memberProfile?.mobileNumber.slice(0, 1)}${"x".repeat(loginV3Data?.memberProfile?.mobileNumber.length - 5)}${loginV3Data?.memberProfile?.mobileNumber.slice(-4)}`}

                </>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-start jlkkedit2">
            <div className="mr-4 cartnamefirst">{translation?.email}</div>
            <div className="cartnamesecond text-break">
              {journeyType ? (
                <>
                  {loginV3Data?.memberProfile?.emailId}

                </>
              ) : (
                <>
                  {loginV3Data?.memberProfile?.emailId?.replace(
                    /^(.)(.*)(.)@(.)(.*)(\.[^.]+)$/,
                    (_, first, middle, last, domainFirst, domainMiddle, extension) =>
                      `${first}${"x".repeat(middle.length)}${last}@${domainFirst}${"x".repeat(domainMiddle.length)}${extension}`
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserInfoAccordion;
